/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card display name instance
 *
 * @module enervee_utils.product_card
 */
function productCardDisplayNameDirective() {
    return {
        restrict: 'E',
        scope: {
            displayName: '@?',
            description: '@'
        },
        template: require('./displayNameView.html')
    };
}

module.exports = productCardDisplayNameDirective;
